import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    setPlanes,
    fetchGrupo,
    setDataGrupo,
    setDataGrupoCopy,
    setGrupoPorIdPlanesData,
    setPlanesDesdeBusqueda,
    updateListGrupoPlanes,
} from '../../actions/planesActions';
import { putGrupoPlanes, deleteGrupoPlanesById, getGrupoPlanesById } from '../../api/axios';
import SafeReactPaginate from '../General/SafeReactPaginate';
import ModalItem from '../General/Modal';
import GoBackArrow from '../General/GoBackArrow';
import BigSpinner from '../General/BigSpinner';
import { toast } from '../../utilities/appToast';
import { withNavigation } from '../General/withNavigation';
import PropTypes from 'prop-types';

const PLANES_LIST_PAGE_SIZE = 10;
const PLANES_FETCH_PAGE_SIZE = 10;
const MAX_PLANES_PAGES_FETCH = 500;

// Wrapper para usar hooks en class component
function PlanesEditWrapper(props) {
    const navigate = useNavigate();
    return <PlanesEdit {...props} navigate={navigate} />;
}

class PlanesEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comision: 0,
            request: null,
            descripcion: "",
            cambioInputChange: false,
            comisionPredeterminada: "",
            planesListaPagina: 1,
            cargandoListaCompleta: true,
        };
        this.descripcionInputRef = React.createRef();
        this._planesEditMounted = false;
    };

    componentDidMount() {
        this._planesEditMounted = true;
        this.props.fetchGrupo({ idGrupoPlan: this.props.idGrupo });
        this.cargarTodosLosPlanesDelGrupo();

        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    componentWillUnmount() {
        this._planesEditMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.idGrupo !== this.props.idGrupo && this.props.idGrupo != null) {
            this.props.fetchGrupo({ idGrupoPlan: this.props.idGrupo });
            this.cargarTodosLosPlanesDelGrupo();
        }
    }

    parsePlanesPagina(res) {
        const d = res?.data ?? {};
        const pag = d.paginationPlan || d.PaginationPlan || d.planes?.paginationPlanes;
        if (pag) {
            const content = pag.content || pag.Content || [];
            const total = pag.total ?? pag.Total ?? content.length;
            const ps = pag.pageSize ?? pag.PageSize ?? PLANES_FETCH_PAGE_SIZE;
            const totalPages = pag.totalPages ?? pag.TotalPages
                ?? Math.max(1, Math.ceil(total / Math.max(ps, 1)));
            return { content, totalPages: Math.max(1, totalPages) };
        }
        const elementos = d.elementos || d.Elementos || [];
        return { content: elementos, totalPages: 1 };
    }

    cargarTodosLosPlanesDelGrupo = async () => {
        const id = Number(this.props.idGrupo);
        if (!id || Number.isNaN(id)) {
            if (this._planesEditMounted) {
                this.setState({ cargandoListaCompleta: false });
            }
            return;
        }

        if (this._planesEditMounted) {
            this.setState({ cargandoListaCompleta: true, planesListaPagina: 1 });
        }

        let all = [];
        try {
            let page = 1;
            let totalPages = 1;
            while (page <= totalPages && page <= MAX_PLANES_PAGES_FETCH && this._planesEditMounted) {
                const res = await getGrupoPlanesById({
                    IdGrupoPlan: id,
                    Page: page,
                    PageSize: PLANES_FETCH_PAGE_SIZE,
                });
                const { content, totalPages: tp } = this.parsePlanesPagina(res);
                all = all.concat(content);
                totalPages = tp;
                page += 1;
            }

            if (!this._planesEditMounted) return;

            this.props.setGrupoPorIdPlanesData({
                paginationPlan: {
                    content: all,
                    total: all.length,
                    page: 1,
                    pageSize: PLANES_FETCH_PAGE_SIZE,
                    totalPages: Math.max(1, Math.ceil(all.length / PLANES_FETCH_PAGE_SIZE)),
                },
            });
        } catch (e) {
            if (this._planesEditMounted) {
                toast.error("No se pudieron cargar los planes del grupo");
                this.props.setGrupoPorIdPlanesData({
                    paginationPlan: {
                        content: [],
                        total: 0,
                        page: 1,
                        pageSize: PLANES_FETCH_PAGE_SIZE,
                        totalPages: 1,
                    },
                });
            }
        } finally {
            if (this._planesEditMounted) {
                this.setState({ cargandoListaCompleta: false });
            }
        }
    };

    handlePlanesListPageClick = (e) => {
        this.setState({ planesListaPagina: e.selected + 1 });
    };

    myChangeHandler = (e) => {
        const numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name === "comision") {

            let esNumero = valor.match(numbersOnly);
            if (esNumero === null) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: "" });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: "" })
                return;
            }
            if (e.target.value > 100) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: 100 });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: 100 })
            } else {
                this.setState({ cambioInputChange: true, comisionPredeterminada: valor });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
            }
        } else {
            this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
        }
    }

    /*refactor método onSubmit*/
    onSubmit = async (event) => {
        event.preventDefault();

        const { descripcion, comision } = this.props.dataGrupo;

        // Validación de campos obligatorios
        if (!descripcion || !comision) {
            if (!descripcion) toast.error("Debe agregar una descripción");
            if (!comision) toast.error("Debe agregar una comisión");
            return;
        }

        // Obtención de IDs de planes
        const obtenerIdPlanes = () => {
            if (this.props.planDesdeBusqueda?.length > 0) {
                return this.props.planDesdeBusqueda.map(plan => plan.id);
            }
            const el = this.props.planes?.elementos;
            if (!el?.length) return [];
            return el.map(plan => plan.idPlan);
        };

        const idPlanes = obtenerIdPlanes();

        // Validación de existencia de planes
        if (idPlanes.length === 0) {
            toast.error("Debe cargar un plan");
            return;
        }

        // Creación del payload
        const data = {
            idUsuario: Number.parseInt(this.props.userId, 10) || 0,
            idGrupoPlan: this.props.idGrupo,
            descripcion,
            comision: Number.parseFloat(comision),
            listaIdsPlanes: idPlanes,
        };

        const grupoPlanes = putGrupoPlanes(data);

        grupoPlanes.then(res => {
            this.props.updateListGrupoPlanes(this.props.grupoPlanes, data)
                .then(() => {
                    toast.success("Grupo de planes guardado");
                    this.return();
                })
                .catch(err => {
                    console.error("Error al actualizar la lista de Grupo Planes:", err);
                    toast.error("No pudo modificarse");
                });
        })
        .catch(err => {
            const apiError = err?.response?.data;

            if (apiError?.errors && apiError.errors.length > 0) {
                apiError.errors.forEach(e => {
                    toast.error(e.message);
                });
            } else {
                toast.error("No pudo modificarse");
            }
        });
    };

    onDelete = () => {
        const req = deleteGrupoPlanesById(this.props.idGrupo);
        req.then(res => {
            toast.success("Grupo de plan borrado");
            this.return();
        })
        .catch(err => {
            const apiError = err?.response?.data;

            if (apiError?.errors && apiError.errors.length > 0) {
                apiError.errors.forEach(e => {
                    toast.error(e.message);
                });
            } else {
                toast.error("No se pudo realizar esta tarea");
            }
        });
    }

    borrarFila = (nroPlan) => {
        let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
        if (jsonPlanDesdeBusqueda !== "[]") {
            let index = this.props.planDesdeBusqueda.findIndex(x => x.numero === nroPlan);
            this.props.planDesdeBusqueda.splice(index, 1);
            this.props.setPlanesDesdeBusqueda(this.props.planDesdeBusqueda);
            this.forceUpdate();
        }
    }

    borrarFilaCargadaInicialmente = (nroPlan) => {
        const elems = [...(this.props.planes?.elementos || [])];
        const index = elems.findIndex(x => x.numeroPlan === nroPlan);
        if (index === -1) return;
        elems.splice(index, 1);
        const totalPages = Math.max(1, Math.ceil(elems.length / PLANES_LIST_PAGE_SIZE));
        this.props.setGrupoPorIdPlanesData({
            paginationPlan: {
                content: elems,
                total: elems.length,
                page: 1,
                pageSize: PLANES_FETCH_PAGE_SIZE,
                totalPages,
            },
        });
        this.setState(prev => ({
            planesListaPagina: Math.min(Math.max(1, prev.planesListaPagina), totalPages),
        }));
    }

    renderPlanesLista = () => {
        const { planDesdeBusqueda, planes } = this.props;

        if (JSON.stringify(planDesdeBusqueda) !== "[]" && planDesdeBusqueda?.length > 0) {
            return (
                <div className="admin-list-stack">
                    {planDesdeBusqueda.map((item, index) => (
                        <div key={item.numero ?? index} className="admin-list-card p-3 admin-list-card--vigente">
                            <div className="row g-2 align-items-center">
                                <div className="col-auto">
                                    <span className="admin-id-badge">{item.numero}</span>
                                </div>
                                <div className="col text-break">
                                    <div className="admin-list-card__title fw-semibold small mb-0">{item.descripcion}</div>
                                </div>
                                <div className="col-auto">
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-danger p-0"
                                        onClick={() => this.borrarFila(item.numero)}
                                        aria-label="Quitar plan del grupo"
                                    >
                                        <i className="fas fa-trash-alt" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        const elems = planes?.elementos;
        if (!elems || elems.length === 0) {
            return (
                <p className="small text-body-secondary mb-0">
                    No hay planes en el grupo. Usá &quot;Agregar planes&quot; para buscarlos y asociarlos.
                </p>
            );
        }

        const totalItems = elems.length;
        const page = this.state.planesListaPagina;
        const slice = elems.slice(
            (page - 1) * PLANES_LIST_PAGE_SIZE,
            page * PLANES_LIST_PAGE_SIZE
        );
        const pageCount = Math.max(1, Math.ceil(totalItems / PLANES_LIST_PAGE_SIZE));

        return (
            <div>
                <div className="admin-list-stack">
                    {slice.map((item, index) => (
                        <div key={item.numeroPlan ?? index} className="admin-list-card p-3 admin-list-card--vigente">
                            <div className="row g-2 align-items-center">
                                <div className="col-auto">
                                    <span className="admin-id-badge">{item.numeroPlan}</span>
                                </div>
                                <div className="col text-break">
                                    <div className="admin-list-card__title fw-semibold small mb-0">{item.descripcion}</div>
                                </div>
                                <div className="col-auto">
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-danger p-0"
                                        onClick={() => this.borrarFilaCargadaInicialmente(item.numeroPlan)}
                                        aria-label="Quitar plan del grupo"
                                    >
                                        <i className="fas fa-trash-alt" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {totalItems > PLANES_LIST_PAGE_SIZE && (
                    <div className="d-flex justify-content-center mt-3">
                        <SafeReactPaginate
                            previousLabel="Anterior"
                            nextLabel="Siguiente"
                            breakLabel="..."
                            breakClassName="break-me"
                            pageCount={pageCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePlanesListPageClick}
                            containerClassName="pagination"
                            subContainerClassName="pages pagination"
                            activeClassName="active"
                            forcePage={page - 1}
                        />
                    </div>
                )}
            </div>
        );
    }

    return = () => {
        this.props.setPlanes([]);
        const previousPath = this.props.location?.state?.from
        if (previousPath !== undefined) {
            if (previousPath.includes('Tipo/Publicaciones/Editar/')) {
                // Viene de Planes
                this.props.navigate(previousPath);
            }
        }
        else {
            // Viene de Tipo Publicacion/Grupo de Planes
            this.props.navigate("/Planes");
        }
    }

    render() {
        let comision;
        if (!this.state.cambioInputChange) {
            comision = this.props.dataGrupo.comision !== undefined ? this.props.dataGrupo.comision : "";
        } else {
            comision = this.state.comisionPredeterminada;
        }

        return (

            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <GoBackArrow />
                                <div>
                                    <h4 className="mb-0 text-body fw-semibold">Editar grupo de planes</h4>
                                    <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">Descripción, comisión y planes asociados.</p>
                                </div>
                            </div>
                            <Link to="/Planes/Busqueda" className="btn btn-sm background-rojo-megatone text-white text-decoration-none">
                                <i className="fa fa-plus-circle me-1" /> Agregar planes
                            </Link>
                        </div>
                    </div>

                    <div className="px-4 pb-4 pt-2">
                    <form className="form-horizontal form-material" onSubmit={this.onSubmit}>

                        <div className="form-group">
                            <div className="row justify-content-evenly">

                                <div className="col-12 col-md-7 mb-3 mb-md-0">
                                    <label htmlFor="firstName" className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        value={this.props.dataGrupo.descripcion ?? ""}
                                        onChange={this.myChangeHandler}
                                        id="firstName"
                                        className="form-control"
                                        ref={this.descripcionInputRef}
                                    />
                                </div>

                                <div className="col-12 col-md-5">
                                    <div className="d-flex align-items-center">
                                        <small className="font-14 applyFont">
                                            <i className="fas fa-percent" />
                                        </small>
                                        <label htmlFor="comisionPlanesEdit" className="label-oscura mx-2">Comisión</label>
                                    </div>
                                    <input
                                        id="comisionPlanesEdit"
                                        name="comision"
                                        value={comision ?? ""}
                                        onChange={this.myChangeHandler}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>
                            </div>
                        </div>

                        <p className="label-oscura d-block mb-2">Planes del grupo</p>
                        {(this.props.isLoading || this.state.cargandoListaCompleta) ? (
                            <div className="d-flex justify-content-center my-3">
                                <BigSpinner message="Cargando planes del grupo..." />
                            </div>
                        ) : (
                            this.renderPlanesLista()
                        )}

                        <div className="row align-items-center justify-content-center mb-3 text-center mt-3">

                            <button
                                type="submit"
                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                disabled={this.props.isLoading || this.state.cargandoListaCompleta}
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el grupo de plan?"
                                onDelete={this.onDelete}
                                centered
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                            />

                            <button
                                onClick={this.return}
                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                            >
                                Cancelar
                            </button>

                        </div>
                    </form>
                    </div>
                </div>
            </div>
        );
    }
}
PlanesEdit.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.shape({
            from: PropTypes.string,
        }),
    }),
    navigate: PropTypes.func,
    // Redux props
    idGrupo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    planes: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        elementos: PropTypes.array,
    })]),
    dataGrupo: PropTypes.shape({
        descripcion: PropTypes.string,
        comision: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    planDesdeBusqueda: PropTypes.array,
    isLoading: PropTypes.bool,
    grupoPlanes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    // Actions props
    setGrupoPorIdPlanesData: PropTypes.func,
    fetchGrupo: PropTypes.func,
    setPlanes: PropTypes.func,
    setDataGrupoCopy: PropTypes.func,
    updateListGrupoPlanes: PropTypes.func,
    setPlanesDesdeBusqueda: PropTypes.func,
}


const mapStateToProps = state => ({
    isLoading: state.planes.loadingPlanes,
    idGrupo: state.planes.id,
    planes: state.planes.grupoPorId,
    planDesdeBusqueda: state.planes.planesDesdeBusqueda,
    dataGrupo: JSON.stringify(state.planes.dataGrupoCopy) !== "{}"
        ? state.planes.dataGrupoCopy
        : state.planes.dataGrupo,
    grupoPlanes: state.planes.grupoPlanes,
    userId: state.general.userId,
});

export default withNavigation(connect(mapStateToProps, {
    setPlanes,
    fetchGrupo,
    setDataGrupo,
    setDataGrupoCopy,
    setGrupoPorIdPlanesData,
    setPlanesDesdeBusqueda,
    updateListGrupoPlanes,
})(PlanesEditWrapper));